import { apiClient as api } from './apiClient';

export interface WishlistItem {
    id: string;
    userId: string;
    nodeId: string | null;
    customTopic: string | null;
    description: string | null;
    voteCount: number;
    status: 'open' | 'in_progress' | 'fulfilled' | 'declined';
    fulfilledCourseId: string | null;
    createdAt: string;
    updatedAt: string;
    user?: {
        id: string;
        username?: string;
        fullName?: string;
        avatarUrl?: string;
    };
    node?: {
        id: string;
        code: string;
        labels: Record<string, string>;
    } | null;
    fulfilledCourse?: {
        id: string;
        title: string;
    } | null;
}

export interface WishlistListResponse {
    items: WishlistItem[];
    total: number;
    page: number;
    limit: number;
}

export interface CreateWishlistParams {
    nodeId?: string;
    customTopic?: string;
    description?: string;
}

export interface WishlistQueryParams {
    status?: string;
    search?: string;
    page?: number;
    limit?: number;
    sortBy?: 'votes' | 'recent';
}

export const wishlistService = {
    list: async (params?: WishlistQueryParams): Promise<WishlistListResponse> => {
        const response = await api.get('/wishlist', { params });
        return response.data;
    },

    create: async (data: CreateWishlistParams): Promise<WishlistItem> => {
        const response = await api.post('/wishlist', data);
        return response.data;
    },

    toggleVote: async (itemId: string): Promise<{ voted: boolean; voteCount: number }> => {
        const response = await api.post(`/wishlist/${itemId}/vote`);
        return response.data;
    },

    getPopular: async (limit = 10): Promise<WishlistItem[]> => {
        const response = await api.get('/wishlist/popular', { params: { limit } });
        return response.data;
    },

    updateStatus: async (
        itemId: string,
        status: string,
        fulfilledCourseId?: string,
    ): Promise<void> => {
        await api.patch(`/wishlist/${itemId}/status`, { status, fulfilledCourseId });
    },

    getMyVotes: async (): Promise<WishlistItem[]> => {
        const response = await api.get('/wishlist/my-votes');
        return response.data;
    },
};
